import { Libraries, useLoadScript } from "@react-google-maps/api";

export const GOOGLE_MAPS_LIBRARIES: Libraries = ["places", "marker"];

export function useGoogleMapsLoader() {
  return useLoadScript({
    googleMapsApiKey: process.env.EXPO_PUBLIC_MAPS_API_KEY || "",
    libraries: GOOGLE_MAPS_LIBRARIES,
  });
}
